import RecipeDetails from './details';
import RecipesFilter from './filter';
import Splide from '@splidejs/splide';

// TODO: criar mecanimos de remoção de localstorage obsoleto por update de versão
const COMPONENT_VERSION = '1.0.0';
const TTL = 30; // min

class Recipes {
  recipe: RecipeDetails;
  filter: RecipesFilter;
  readonly masterdataConfig = {
    entity: {
      RR: {
        name: 'receitas',
        commonFields: {
          id: true,
          highlight: true,
          featuredImage: false,
          author: true,
          relatedProducts: true,
          notShowInProducts: true,
          categoryId: true,
          categoryId2: true,
          categoryId3: true,
          categoryId4: true,
          categoryId5: true,
          difficulty: true,
          name: true,
          preparationTime: false,
          shortname: false,
          slug: true,
          visible: true,
          yelds: false,
          urlVersion: true,
          createdIn: true,
          updatedIn: false,
        },
      },
      RA: {
        name: 'autores',
        commonFields: {
          id: true,
          description: false,
          imageUrl: false,
          instagramUsername: false,
          name: true,
        },
      },
      RC: {
        name: 'categorias',
        commonFields: {
          id: true,
          description: false,
          enabled: true,
          iconUrl: false,
          name: true,
          slug: true,
          type: true,
        },
      },
      RE: {
        name: 'dificuldades',
        commonFields: {
          id: true,
          name: true,
        },
      },
    },
  };
  readonly config = {
    selectors: {
      shelfItemTemplate: '#shelf-item-receitas',
      shelfItemProdRelTemplate: '#shelf-item-receitas-produto',
      shelfBlockRelProduct: '[data-shelf-type="highlight-receitas-produto"]',
      shelfBlockHighlight: '[data-shelf-type="highlight-receitas"]',
      shelfBlockFiltered: '[data-shelf-type="filter-receitas"]',
      shelfFilterItem: '#shelf-filter-item-receitas',
      shelfBlockbtnShowMore: '[data-shelf-action="carregar-mais-receitas"]',
      filterBar: '.rnk-filtro-receita',
    },
  };

  private DB: typeof window.storeTheme.helpers.db;
  private masterdata: {
    receitas?: IVtexMasterdata;
    autores?: IVtexMasterdata;
    categorias?: IVtexMasterdata;
    dificuldades?: IVtexMasterdata;
  };

  private templateRender = {
    shelfItemTemplate: (obj) => {
      const template = document.querySelector(this.config.selectors.shelfItemTemplate)?.innerHTML || '';
      if (!template) {
        return;
      }
      return window.storeTheme.helpers.mustache.render(template, obj);
    },
    shelfItemProdRelTemplate: (obj) => {
      const template = document.querySelector(this.config.selectors.shelfItemProdRelTemplate)?.innerHTML || '';
      if (!template) {
        return;
      }
      return window.storeTheme.helpers.mustache.render(template, obj);
    },
  };

  /**
   * Construtor
   */
  constructor() {
    this.masterdata = Object.values(this.masterdataConfig.entity).reduce((stack, item) => {
      Object.assign(stack, { [item.name]: null });
      return stack;
    }, {});

    //@ts-ignore
    this.DB = new window.storeTheme.helpers.db(`receitas-${COMPONENT_VERSION}`, {
      autoload: true,
      env: 'BROWSER',
      databaseVersion: `${COMPONENT_VERSION}-1`,
      autoloadCallback: async () => {
        await this.initSchema();
        this.listItems();
        this.mountShelfBlockHighlight();
        this.mountShelfForProductPage();
        // se houver filtro na página
        if (document.querySelector(this.config.selectors.shelfFilterItem)) {
          this.filter = new RecipesFilter({
            selectors: this.config.selectors,
            DB: this.DB,
            templateRender: this.templateRender,
          });
        }

        const urlProps = window.storeTheme.helpers.url.getJsonFromUrl();
        const containerRecipe = document.querySelector('[data-type="container-detalhes-receitas"] > .row');
        var slugLocal = '';

        if (containerRecipe) {
          slugLocal = containerRecipe.getAttribute('id')?.replace('receita-', '');
        } else {
          slugLocal = null;
        }

        if (slugLocal || urlProps?.receita) {
          this.recipe = new RecipeDetails({
            DB: this.DB,
            masterdata: this.masterdata,
            slug: slugLocal ? slugLocal : urlProps.receita,
            getItemsByFindParams: this.getItemsByFindParams.bind(this),
            mountShelBlock: this.mountShelBlock.bind(this),
          });
        } else {
          if (document.querySelector('#detalhes-receitas')) {
            console.warn(
              '🥩 Estamos em uma página de detalhe de receita, mas não encontramos a slug da receita na URL da página',
            );
          }
        }
      },
      autosave: true,
      autosaveInterval: 5000,
    });

    const template = document.querySelector(this.config.selectors.shelfItemTemplate)?.innerHTML || '';
    if (!template) {
      console.warn('🥩 Template para prateleira de receitas em destaque não está disponível nesta página');
      return;
    }

    // parse templates
    window.storeTheme.helpers.mustache.parse(template);
  }

  /**
   * Inicia o esquema de dados para a aplicação offline
   */
  private async initSchema() {
    this.createIndexFromRemote();

    Object.keys(this.masterdataConfig.entity)
      .reduce((stack, key) => {
        stack.push({
          name: this.masterdataConfig.entity[key].name,
          indices: Object.keys(this.masterdataConfig.entity[key].commonFields).filter((field) => {
            return this.masterdataConfig.entity[key].commonFields[field] && field !== 'id';
          }),
        });
        return stack;
      }, [])
      .forEach((item) => {
        const entries = this.DB.getCollection(item.name);
        if (entries === null) {
          const collection = this.DB.addCollection(item.name, {
            indices: item.indices,
            unique: ['id'],
            ttl: TTL * 60000,
            ttlInterval: 60000,
          });

          if (item.name === 'receitas') {
            // montar transformer já para items apenas com destaque
            collection.addTransform('highlight', [
              {
                type: 'find',
                value: {
                  visible: { $eq: true },
                  highlight: { $eq: true },
                },
              },
            ]);

            // montar trasnformer com filtro já de itens visíveis
            collection.addTransform('visible', [
              {
                type: 'find',
                value: {
                  visible: { $eq: true },
                },
              },
            ]);
          }
        }
      });

    // window.storeTheme.helpers.events.ready
    if (
      !this.DB.getCollection('receitas').count() ||
      !window.storeTheme.helpers.storage.read('fallback-ttl-reciples')
    ) {
      window.storeTheme.helpers.storage.save('fallback-ttl-reciples', 1, TTL);
      await this.populateIndex();
    }

    return true;
  }

  /**
   * Cria o objeto para consulta ao indice remoto
   */
  private createIndexFromRemote() {
    Object.keys(this.masterdataConfig.entity).forEach(async (entityId) => {
      this.masterdata[this.masterdataConfig.entity[entityId].name] = window.storeTheme.helpers.vtexMasterdata({
        entity_sigla: entityId,
      });
    });
  }

  /**
   * Utilizando o objeto para consulta no indice remoto, realiza as consultas e popula os dados locais com a base de até 2500 itens
   */
  private async populateIndex() {
    const data = (
      await Promise.all(
        Object.keys(this.masterdataConfig.entity).map(async (entityId) => {
          const name = this.masterdataConfig.entity[entityId].name;
          const data = (await this.masterdata[name].get({
            fields: Object.keys(this.masterdataConfig.entity[entityId].commonFields).join(','),
            where: null,
            range: '0-2500',
          })) as [];

          return {
            entityId,
            name,
            items: data,
          };
        }),
      )
    ).reduce((stack, item) => {
      Object.assign(stack, {
        [item.entityId]: item,
      });
      return stack;
    }, {});

    const getEntityNameFromId = (entity, id) => {
      if (!id) {
        return null;
      }

      const cat = data[entity].items.find((item) => item.id === id);
      if (cat) {
        return cat.name;
      }

      return null;
    };

    // tratamento de nomenclaturas de itens associativos
    Object.values(data).map(async ({ entityId, name, items }) => {
      if (entityId === 'RR') {
        items = items.map((item) => {
          const cats = [
            item.categoryId ? getEntityNameFromId('RC', item.categoryId) : '',
            item.categoryId2 ? getEntityNameFromId('RC', item.categoryId2) : '',
            item.categoryId3 ? getEntityNameFromId('RC', item.categoryId3) : '',
            item.categoryId4 ? getEntityNameFromId('RC', item.categoryId4) : '',
            item.categoryId5 ? getEntityNameFromId('RC', item.categoryId5) : '',
          ].filter((item) => !!item);
          Object.assign(item, {
            link: item?.urlVersion === 2 ? `/receitas/${item.slug}` : `/receitas/detalhes?receita=${item.slug}`,
            categoryName: getEntityNameFromId('RC', item.categoryId),
            categoriesNames: cats,
            relatedProducts: (item.relatedProducts || '').split(',').map((item) => item.trim()),
            notShowInProducts: (item.notShowInProducts || '').split(',').map((item) => item.trim()),
            authorName: getEntityNameFromId('RA', item.author),
            difficultyName: getEntityNameFromId('RE', item.difficulty),
            createdIn: new Date(item.createdIn).getTime(),
            updatedIn: item.updatedIn ? new Date(item.updatedIn).getTime() : null,
          });
          return item;
        });
      }
      const collection = this.DB.getCollection(name);
      collection.clear();
      collection.insert(items);
    });
    this.DB.saveDatabase();
    return data;
  }

  /**
   * Retorna os itens marcados como destaque
   *
   * @returns Promise
   */
  private async getHighlightItems() {
    return this.DB.getCollection('receitas').chain('highlight').data();
  }

  async getItemsByFindParams(findObject = {}, limit = 4) {
    const collection = this.DB.getCollection('receitas');
    // obter as chaves de filtros
    const keys = Object.keys(findObject);
    // verificar se foi passado uma lista especifica de itens
    const orderByKeyIn = keys.find((key) => !!findObject[key].hasOwnProperty('$in'));
    let arraySort;
    // obter a lista de itens
    if (orderByKeyIn) {
      arraySort = findObject[orderByKeyIn].$in;
    }

    const data = await collection
      .chain()
      .find(Object.assign({ visible: { $eq: true } }, findObject))
      .simplesort('createdIn', true)
      .offset(0)
      .limit(limit)
      .data();

    // se existir uma lista para ordenar e existir dados em data
    if (arraySort?.length && data?.length) {
      // ordenar a lista de itens
      data.sort((a, b) => {
        const aIndex = arraySort.indexOf(a[orderByKeyIn]);
        const bIndex = arraySort.indexOf(b[orderByKeyIn]);
        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      });
    }

    return data;
  }

  async mountShelBlock(domElement, items, template = 'shelfItemTemplate', props = {}) {
    const perPage = +domElement.getAttribute('data-per-page');
    let itemSplideClass = $('.rnk-container-prateleira-receitas ul').hasClass('splide__list') ? ' splide__slide' : '';    

    domElement.innerHTML = items
      .map((recipe, index) => {
        const attrs = {
          ...recipe,
          ...props,
        };        

        const visible = perPage && !isNaN(perPage) ? index + 1 <= perPage : true;
        return this.templateRender?.[template]({
          ...attrs,
          classNames: `${attrs?.classNames + itemSplideClass || ''} ${visible ? '' : 'd-none'}`,
        });
      })
      .join('');

      if($('.rnk-container-prateleira-receitas ul.splide__list').length > 0) {
        $('.rnk-container-prateleira-receitas ul.splide__list').each((i, comp) => {
          new Splide(`#rnk-receitas-splide-${i + 1}`, {
            type: 'loop',
            perPage: 2
          }).mount();
        })
      }   
      

    if (perPage && !isNaN(perPage)) {
      const $group = $(domElement);
      const $items = $group.children();      
      const $btn = $group.next('[data-shelf-action]');
      if (items.length < perPage) {
        $btn.hide();
        return;
      }
      $btn.on('click', (event) => {
        event.preventDefault();
        $items.filter(':hidden').slice(0, perPage).removeClass('d-none');
        if (!$items.filter(':hidden').length) {
          $btn.hide();
        }
      });
    }
  }

  /**
   * Monta prateleira de receitas relacionadas ao produto sendo visualizado, na página de detalhe de produto da loja
   */
  async mountShelfForProductPage() {
    if (window?.skuJson?.productId) {
      const $box = document.querySelector(this.config.selectors.shelfBlockRelProduct);
      if (!$box) {
        return;
      }

      const items = await this.getItemsByFindParams({
        relatedProducts: { $contains: `${window?.skuJson?.productId}` },
        notShowInProducts: { $containsNone: `${window?.skuJson?.productId}` },
      });      

      if (items.length) {                
        this.mountShelBlock($box, items.slice(0, 3), 'shelfItemProdRelTemplate');
        document.querySelector('.rnk-receitas-relacionadas').classList.remove('d-none');
      }      
    }
  }

  /**
   * Monta HTML e popula no document os itens com destaque caso encontre a prateleira para exibição.
   */
  async mountShelfBlockHighlight(selector = this.config.selectors.shelfBlockHighlight) {
    const $box = document.querySelector(selector);
    if ($box) {
      let propsItems;
      let recipleFilters;
      const limit = +$box.getAttribute('data-limit') || 4;

      try {
        recipleFilters = JSON.parse($box.getAttribute('data-reciple-filter'));
        propsItems = JSON.parse($box.getAttribute('data-reciple-props') || '{}');
      } catch (e) {
        console.error(e);
      }

      let items = [];
      if (recipleFilters) {
        const customItems = await this.getItemsByFindParams(recipleFilters, limit); // { slug: { $in: recipleOnParams } };
        items = customItems;
      }

      if (items.length < limit) {
        const highlightItems = await this.getHighlightItems();
        items = items.concat(highlightItems);
      }

      this.mountShelBlock($box, items.slice(0, limit), undefined, propsItems);
      return;
    }
    console.warn('🥩 Bloco para apresentar receitas em destaque não está disponível nesta página');
  }

  /**
   * Lista receitas com id, nome, slug, imagem e descrição
   */
  async listItems() {
    var collection = await this.DB.getCollection('receitas');
    var version = {} as any;
    const $list = document.querySelector('#inicio-conteudo .list-group');
    const $generator = document.querySelector('#inicio-conteudo .content-generator');
    const $inputSearch = document.querySelector('#search');
    const statusURL = document.querySelector('#status-url');
    const template = (item) => `
    <button type="button" class="list-group-item list-group-item-action">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1 w-75 text-left">${item.name}</h5>
        <small class="w-25 text-right">${item.urlVersion === 2 ? 'Gerado' : 'Não gerado'}</small>
      </div>

      <p class="mb-1">${item.slug}</p>
    </button>
  `;

    if (statusURL) {
      statusURL.addEventListener('click', (event: any) => {
        const radio = statusURL.querySelector(':checked');
        const radioSelected = radio.getAttribute('id');

        const items = collection
          .chain()
          .find({
            visible: { $eq: true },
            urlVersion:
              radioSelected === 'url-generated'
                ? { $eq: 2 }
                : radioSelected === 'url-not-generated'
                ? { $eq: null }
                : { $ne: 0 },
          })
          .data();

        $list.innerHTML = items
          .map((item) => {
            return template(item);
          })
          .join('');
      });
    }

    console.log(collection);

    if ($inputSearch) {
      $inputSearch.addEventListener('keyup', (event: any) => {
        const value = event.target.value;

        const items = collection
          .chain()
          .find({
            name: { $regex: new RegExp(value, 'i') },
            visible: { $eq: true },
            ...version,
          })
          .data();

        $list.innerHTML = items
          .map((item) => {
            return template(item);
          })
          .join('');
      });
    }

    if ($list) {
      $list.innerHTML = collection
        .chain()
        .find({
          visible: { $eq: true },
          ...version,
        })
        .data()
        .map((item) => {
          return template(item);
        })
        .join('');

      $list.addEventListener('click', async (event: any) => {
        const $target = event.target;
        const $content = document.querySelector('#inicio-conteudo .content-generator');

        const slug = $target.closest('.list-group-item').querySelector('p').innerText;
        const reciple = new RecipeDetails({
          DB: this.DB,
          masterdata: this.masterdata,
          slug: slug,
          updateRecipeData: false,
        });

        await reciple.getCompleteRecipeData();

        const item = collection.findOne({ slug });

        const template = (item) => `
            <div class="mb-3">
              ${item.featuredImage ? `<img src="${item.featuredImage}" class="img-fluid mb-3" alt="${item.name}">` : ''}

              <h3>Conteudo:</h3>

              <div>
                <div class="mb-3">
                  <p class="font-weight-bold">ID:</p>
                  <p id="id">${item.id}</p>
                </div>

                <div class="mb-3">
                  <p class="font-weight-bold">Slug:</p>
                  <p id="slug">${item.link}</p>
                </div>

                <div class="mb-3">
                  <p class="font-weight-bold">Url para pesquisa:</p>
                  <p id="slug">${item.slug}</p>
                </div>

                <div class="mb-3">
                  <p class="font-weight-bold">Titulo:</p>
                  <p id="name">${item.name}</p>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div id="meta-tags" class="mb-5">
                <label for="generatedMeta" class="font-weight-bold d-flex justify-content-between">
                  <h3>Meta tags:</h3>
                  <button type="button" class="btn btn-primary btn-sm">Gerar Meta-Tags</button>
                </label>
                <textarea class="form-control" id="generatedMeta" rows="4"></textarea>
              </div>

              <div id="content">
                <label for="generatedContent" class="font-weight-bold d-flex justify-content-between">
                  <h3>Conteúdo:</h3>
                  <button type="button" class="btn btn-primary btn-sm">Gerar Conteúdo</button>
                </label>
                <textarea class="form-control" id="generatedContent" rows="4"></textarea>
              </div>
            </div>
          `;

        $content.innerHTML = template(item);
        const $metaTags = document.querySelector('#inicio-conteudo .content-generator #meta-tags');
        const $contentGenerator = document.querySelector('#inicio-conteudo .content-generator #content');

        $contentGenerator?.addEventListener('click', (event: any) => {
          const $target = event.target;

          if ($target.closest('button')) {
            const $button = $target.closest('button');
            const $generatedContent = $target.closest('.form-group').querySelector('#generatedContent') as any;

            $button.innerText = 'Copiar';
            $button.classList.add('btn-success');

            $generatedContent.select();
            document.execCommand('copy');
          }

          const id = $target.closest('.content-generator').querySelector('#id').innerText;
          const item = collection.findOne({ id });

          console.log(reciple);

          const recipesTemplate = (obj: any) => {
            return window.storeTheme.helpers.mustache.render(
              document.querySelector('#detalhes-receitas')?.innerHTML || '',
              obj,
            );
          };

          document.querySelector('#generatedContent').innerHTML = recipesTemplate(item);
        });

        $metaTags?.addEventListener('click', (event: any) => {
          const $target = event.target;
          const template = (item) => `
              <!-- SOCIAL SHARE -->
              <title>${item.name ? item.name + ' - ' : ''}Receitas Swift</title>
              <meta property="og:type" content="article" />
              <meta name="description" content="${
                item.description
                  ? item.description
                  : 'As melhores ideias para preparar pratos incríveis na sua casa. Escolha por tipo, dificuldade e tempo de preparo. Confira!'
              }" />
              <meta property="og:title" content="${item.name ? item.name + ' - ' : ''}Receitas Swift" />
              <meta property="og:image" content="${
                item.imageUrl ? item.imageUrl : 'https://swift-static.online.pro.br/arquivos/rnk-banner-receitas.png'
              }" />
              <meta property="og:description" content="${
                item.description
                  ? item.description
                  : 'As melhores ideias para preparar pratos incríveis na sua casa. Escolha por tipo, dificuldade e tempo de preparo. Confira!'
              }" />
              <link rel="canonical" href="https://www.swift.com.br${item.link}">
            `;

          if ($target.closest('button')) {
            const $button = $target.closest('button');
            const $generatedMeta = $target.closest('.form-group').querySelector('#generatedMeta') as any;

            $button.innerText = 'Copiar';
            $button.classList.add('btn-success');

            $generatedMeta.select();
            document.execCommand('copy');
          }

          const id = $target.closest('.content-generator').querySelector('#id').innerText;
          const item = collection.findOne({ id });

          document.querySelector('#generatedMeta').innerHTML = template(item);
        });
      });
    }

    return collection.data;
  }
}

const receitas = new Recipes();

window.storeTheme = window.storeTheme || ({} as StoreTheme);
Object.assign(window.storeTheme, { receitas });

export default {};
